module.exports = __webpack_public_path__ + "static/lightning-cover-669bca3abf648e02283c9db985ad1408.jpg";